/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ResourceSecretManagerCredentialsInfo } from './resourceSecretManagerCredentialsInfo';
import { ResourceProvider } from './resourceProvider';
import { ResourceAssignmentDetails } from './resourceAssignmentDetails';
import { ResourceState } from './resourceState';
import { ResourceType } from './resourceType';
import { ResourceCategory } from './resourceCategory';


export interface ResourceInfo { 
    resource_id?: string;
    provider?: ResourceProvider;
    managed?: boolean;
    type?: ResourceType;
    category?: ResourceCategory;
    state?: ResourceState;
    metadata?: object;
    created_by?: string;
    created_time?: Date;
    /**
     * Any comment related to Resource to be onboarded.
     */
    note?: string;
    secret_manager_credentials?: Array<ResourceSecretManagerCredentialsInfo>;
    sharable?: boolean;
    updated_by?: string;
    updated_time?: Date;
    assigned_vcf_orgs?: Array<ResourceAssignmentDetails>;
}
export namespace ResourceInfo {
}


